<template>
    <div id="bar" ref="bar"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: {
      barDataProps: {
        type: Array,
        default: []
      },
    },
    data() {
        return {
          myChart: null,
          labelData: [],
          dataList: []
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.bar);
        this.init();
        window.addEventListener("resize", this.handleWindowResize);
    },
    watch: {
        barDataProps: {
            handler(newValue) {
                if(newValue){
                    this.labelData = newValue[0];
                    this.dataList = newValue[1];
                    this.init();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
              let option = {
                // title: {
                //   text: ''
                // },
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  }
                },
                legend: {
                  show: false
                },
                grid: {
                  left: '1%',
                  right: '4%',
                  bottom: '3%',
                  top: '2%',
                  containLabel: true
                },
                xAxis: {
                  type: 'value',
                  boundaryGap: [0, 0.01]
                },
                yAxis: {
                  type: 'category',
                  data: this.labelData
                },
                series: [{
                    name: '',
                    type: 'bar',
                    data: this.dataList
                  },],
              };
              option && this.myChart.setOption(option);
            })
            
        }, 
        handleWindowResize() {
            if (!this.myChart) return;
            this.myChart.resize();
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
}



</script>
<style scoped>
#bar {
    width: 100%;
    height: 100%;
}
</style>